import React, { useState } from 'react';

// Feature 6: Floating "Built with" tech stack showcase + performance score badge
const TECH = [
  { name: 'React 18',    icon: '⚛️', color: '#61DAFB', desc: 'UI Framework' },
  { name: 'LangChain',   icon: '🦜', color: '#1C3C3C', desc: 'AI Orchestration' },
  { name: 'Azure',       icon: '☁️', color: '#0078D4', desc: 'Cloud Platform' },
  { name: '.NET 8',      icon: '🔷', color: '#512BD4', desc: 'Backend' },
  { name: 'Flutter',     icon: '🐦', color: '#02569B', desc: 'Mobile' },
  { name: 'OpenAI',      icon: '🤖', color: '#10A37F', desc: 'AI / LLM' },
  { name: 'PostgreSQL',  icon: '🐘', color: '#336791', desc: 'Database' },
  { name: 'Docker',      icon: '🐳', color: '#2496ED', desc: 'Containers' },
];

export default function TechStackBadge() {
  const [open, setOpen] = useState(false);

  return (
    <div className={`tsb-wrap ${open ? 'open' : ''}`}>
      <button className="tsb-trigger" onClick={() => setOpen(v => !v)} aria-label="View tech stack">
        <span className="tsb-icons">⚛️☁️🤖</span>
        <span className="tsb-label">Tech Stack</span>
        <span className="tsb-arrow">{open ? '▼' : '▲'}</span>
      </button>
      {open && (
        <div className="tsb-panel">
          <div className="tsb-head">🛠️ Our Technology Stack</div>
          <div className="tsb-grid">
            {TECH.map(t => (
              <div key={t.name} className="tsb-item">
                <span className="tsb-ic">{t.icon}</span>
                <div>
                  <div className="tsb-name">{t.name}</div>
                  <div className="tsb-role" style={{ color: t.color }}>{t.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
